import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";
const valEmp = __CONFIG__.empresa;

const LISTADO_COMERCIALIZADOR = 'LISTADO_COMERCIALIZADOR';
const LOADER = 'LOADER';
const MODULO = 'MODULO';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let params;
    let id = ''
    if (valEmp === 'fage'){
        id = id_emp[6];
        params = { id };
    }else{
        id = id_emp[5];
        params = { id };
    }
    dispatch(setLoader(true));
    api.get('/comercializador', params).then((response)=>{
        dispatch({ type: LISTADO_COMERCIALIZADOR, data: response });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al listar distribuidores',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const registroComercializador = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormComercializador.values;
    let id_empresa = '';
    if (valEmp === 'fage'){
        id_empresa = id_emp[6]
    }else{
        id_empresa = id_emp[5]
    }
    const formData = {
        comercializador: data.comercializador,
        empresa: id_empresa
    }
    dispatch(setLoader(true));
    api.post('/comercializador/', formData).then(() => {
        NotificationManager.success(
        'Distribuidor creado',
        'Exito',
        3000
    );
    let ruta = '';
    if (valEmp === 'fage'){
        ruta = `/lfg/registro_sanitario/${id_emp[6]}/comercializador`
        dispatch(push(ruta));
    }else{
        ruta = `/registro_sanitario/${id_emp[5]}/comercializador`
        dispatch(push(ruta));
    }
    }).catch((error) => {
    NotificationManager.error(
        error.msj,
        'Error',
        2000
    );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const modificarComercializador = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const datos = getStore().form.FormComercializador.values;
    const id = datos.id;
    const formData = {
        id: id,
        comercializador: datos.comercializador,
    }
    dispatch(setLoader(true));
    api.put(`/comercializador/${id}/`, formData).then(() => {
        NotificationManager.success(
            'Distribuidor modificado correctamente',
            'Exito',
            3000
        );
        let ruta = '';
        if (valEmp === 'fage'){
            ruta = `/lfg/registro_sanitario/${id_emp[6]}/comercializador`
            dispatch(push(ruta));
        }else{
            ruta = `/registro_sanitario/${id_emp[5]}/comercializador`
            dispatch(push(ruta));
        }
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al modificar distribuidor',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/comercializador/${id}`).then((response) => {
        dispatch(initializeForm('FormComercializador', response ));
    }).catch((error)=>{
        
        NotificationManager.error(
            'Ocurrió un error al consultar distribuidor',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en buscar modulo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const actions = {
    listar,
    registroComercializador,
    modificarComercializador,
    leer,
    getModulo
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LISTADO_COMERCIALIZADOR]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
};

export const initialState = {
    loader: false,
    modulo: [],
    data: [],
};

export default handleActions(reducers, initialState)
 